import * as materials from "@lts/materials/legacy/legacy-fire";
export { materials };
export default materials;
